const getCustomListSource = config => {
  const toggle = config?.toggleSourceType || {};
  const manualListId = toggle.manualListId || '';
  const slug = toggle.customListSlug || '';

  if (toggle.selected?.value === 'ProductsListInput' && manualListId) {
    return { listId: manualListId, listKind: 'manual' };
  }

  if (slug) {
    return { listId: slug, listKind: 'named' };
  }

  if (manualListId) {
    return { listId: manualListId, listKind: 'manual' };
  }

  return null;
};

export default getCustomListSource;
